export { default } from './TableRow';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/TableRow/index.js
// module id = 368
// module chunks = 0